import { useEffect } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { AppDispatch, StoreState } from '../../redux/store';
import { getUserBanks } from '../../redux/users/usersSlice';

const useFetchUserBanks = () => {
  const dispatch = useDispatch<AppDispatch>();
  const {currentUser, loading, error} = useSelector((state: StoreState) => state.users);

  useEffect(() => {
    if ((!currentUser || !currentUser.infos.banks)) {
      dispatch(getUserBanks());
    }
  }, [currentUser, dispatch]);

  const banks = currentUser?.infos.banks || [];
  return {loading, error, banks};
};

export default useFetchUserBanks;

